import React, { useEffect, useState } from "react";
import style from "./proReportShow.module.scss";
import Skeleton from "../skeleton/skeleton"

const ListSkeleton = (props) => {

    return <div className={style.wrapper}>
        <div className={style.headerWrapper}>
            <div className={style.headerButtonWrapper} style={{ direction: 'rtl' }}>
                <div className={style.backButton} style={{ marginTop: '27px', marginBottom: '20px', padding: '0' }}>
                    <Skeleton type='rectangle' width='103px' height='44px' />
                </div>
                <div className={style.buttonContainer}>
                    <Skeleton type='rectangle' width='170px' height='44px' />
                </div>
            </div>
            <h3><Skeleton type='rectangle' width='130px' height='44px' /></h3>
        </div>
        <div className={style.searchbarWrapper}>
            <Skeleton type='rectangle' width='100%' height='48px' />
        </div>
        <div className={style.dropdownWrapper} style={{ display: 'inline-flex', gap: '12px', flexWrap: 'wrap', marginTop: '40px', direction: 'rtl' }}>
            <div className={style.dropdownBox}><Skeleton type='rectangle' width='130px' height='48px' /></div>
            <div className={style.dropdownBox}><Skeleton type='rectangle' width='130px' height='48px' /></div>
            <div className={style.dropdownBox}><Skeleton type='rectangle' width='130px' height='48px' /></div>
            <div className={style.dropdownBox}><Skeleton type='rectangle' width='130px' height='48px' /></div>
        </div>
        <div className={style.cardComponents}>
            <div className={style.pagination}>
                <div className={style.Dropdown}>
                    <div style={{ marginLeft: '15px' }}>
                        <Skeleton type='rectangle' width='250px' height='48px' />
                    </div>
                    <div style={{ marginLeft: '15px' }}>
                        <Skeleton type='rectangle' width='100px' height='48px' />
                    </div>
                    <div style={{ marginLeft: '15px' }}>
                        <Skeleton type='rectangle' width='100px' height='48px' />
                    </div>
                </div>
            </div>
            <div style={{ marginTop: '15px', display: 'flex', flexDirection: 'column' }}>
                <div style={{ marginBottom: '20px' }}>
                    <Skeleton type='rectangle' width='100%' height='270px' />
                </div>
                <div style={{ marginBottom: '20px' }}>
                    <Skeleton type='rectangle' width='100%' height='270px' />
                </div>
                <div style={{ marginBottom: '20px' }}>
                    <Skeleton type='rectangle' width='100%' height='270px' />
                </div>
                <div style={{ marginBottom: '20px' }}>
                    <Skeleton type='rectangle' width='100%' height='270px' />
                </div>
                <div style={{ marginBottom: '20px' }}>
                    <Skeleton type='rectangle' width='100%' height='270px' />
                </div>
            </div>
            <div className={style.paginationTwo}>
                <Skeleton type='rectangle' width='250px' height='48px' />
            </div>
        </div>
    </div>
}
export default ListSkeleton;
